export { default } from "./page-content";
